import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiSvgModule, TuiTextfieldControllerModule } from '@taiga-ui/core';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-version-available',
  standalone: true,
  imports: [TuiSvgModule, TuiTextfieldControllerModule, TranslocoPipe],
  templateUrl: './version-available.component.html',
  styleUrl: './version-available.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionAvailableComponent {}
